

const getPreferredLocale = (navigator: Navigator) => {
    // if browser navigator api is not available, return en as fallback
    if (!navigator) return 'en' 
    const supportedLocales = ['en', 'es', 'pt']
    let locale = (navigator.language || 'en').substring(0, 2);
    if (navigator.languages && navigator.languages.length) {
        locale = navigator.languages[0].substring(0, 2);
    }
    return supportedLocales.includes(locale) ? locale : 'en';
}
export default getPreferredLocale;